module.exports = __webpack_public_path__ + "static/media/r25.04cca17e.jpg";